<!-- Animated Background Shapes -->
<div class="bg-shapes">
  <div class="bg-shape bg-shape-1"></div>
  <div class="bg-shape bg-shape-2"></div>
  <div class="bg-shape bg-shape-3"></div>
  <div class="bg-shape bg-shape-4"></div>
</div>

<router-outlet></router-outlet>
<!--<div fxLayout="column">-->
<!--  <div fxLayout="row">-->
<!--    <app-text-editor (editorOutputContent)="updateMessage($event)"></app-text-editor>-->
<!--  </div>-->
<!--</div>-->
